import { AlertTriangle } from "lucide-react";
import { motion } from "framer-motion";

const ErrorFallback = ({ error, resetErrorBoundary }) => (
  <div
    role="alert"
    className="flex items-center justify-center min-h-screen bg-white dark:bg-zinc-950 px-4"
  >
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="w-full max-w-md bg-white dark:bg-zinc-900 rounded-3xl dark:border-zinc-800 p-8 text-center space-y-16"
    >
      {/* Icône encadrée */}
      {/* <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-gradient-to-br from-red-500 to-red-700 text-white shadow-lg">
        <AlertTriangle className="w-8 h-8" />
      </div> */}

      {/* Titre */}
      <h2 className="text-2xl font-bold text-zinc-800 dark:text-zinc-100">
        Désolé une erreur est survenue
      </h2>

      {/* Message d'erreur (optionnel) */}
      {/* {error?.message && (
        <p className="text-sm text-zinc-600 dark:text-zinc-400">
          {error.message}
        </p>
      )} */}

      {/* Bouton */}
      <motion.button
        whileTap={{ scale: 0.95 }}
        whileHover={{ scale: 1.03 }}
        onClick={resetErrorBoundary}
        className="inline-flex items-center justify-center px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-full font-medium shadow-md transition-all"
      >
        Réessayer
      </motion.button>
    </motion.div>
  </div>
);

export default ErrorFallback;
